import React from 'react'

const AboutUs = () => {
  return (
    <>
      <section className="about-section text-center" id="about">
            <div className="container px-4 px-lg-5">
                <div className="row gx-4 gx-lg-5 justify-content-center align-items-center">
                    <div className="col-lg-8">
                        <h2 className="text-white mb-4">Astronomicaly Factual!</h2>
                        <p className="text-white-50">
                            Astronomical Facts is a page to bring you factual data regarding the planets and stars you can find in space!
                        </p>
                        <img className="img-fluid" src="assets/img/pngimg.com - telescope_PNG62 edited.png" alt="..." />
                    </div>
                </div>
                
            </div>
        </section>
    </>
  )
}

export default AboutUs
